import React, { useCallback, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import '../styles/AnnouncementBar.css';

import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

const AUTHOR_URL = 'https://www.amazon.com/author/robertfalkenberg';

const AnnouncementBarComponent = () => {
  useEffect(() => {
    logEvent(analytics, 'view_promotion', {
      promotion_id: 'announcement_bar_series',
      promotion_name: 'Sierra Justice Series',
      creative_name: 'Top Announcement Bar',
      item_name: 'Sierra Justice Series',
    });
  }, []);

  const handleCtaClick = useCallback(() => {
    logEvent(analytics, 'select_promotion', {
      promotion_id: 'announcement_bar_series',
      promotion_name: 'Sierra Justice Series',
      creative_name: 'Top Announcement Bar',
      item_name: 'Sierra Justice Series',
      retailer_name: 'Amazon Author Page',
      retailer_link: AUTHOR_URL,
    });
  }, []);

  return (
    <div
      className="announcement-bar exciting"
      role="region"
      aria-label="Site Announcement"
    >
      <div className="announcement-content">
        <span className="announcement-icon-decorative">
          <FontAwesomeIcon icon={faGift} aria-hidden="true" />
        </span>

        <span className="announcement-text">
          Access the whole Sierra Justice Series here!
        </span>

        <motion.a
          href={AUTHOR_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="announcement-cta-button"
          onClick={handleCtaClick}
          whileHover={{ y: -2 }}
          transition={{ type: 'tween', duration: 0.2 }}
        >
          <span>Browse the Series</span>
          <span className="chevron" aria-hidden="true">
            <FontAwesomeIcon icon={faArrowRight} />
          </span>
        </motion.a>
      </div>
    </div>
  );
};

export default React.memo(AnnouncementBarComponent);
